import React, { createContext, useContext, useState, useCallback } from 'react';
import AuthModal from '../components/Auth/AuthModal';

const AuthModalContext = createContext(null);

export function AuthModalProvider({ children }) {
  const [state, setState] = useState({ isOpen: false, mode: 'signup', onSuccess: null });

  const openAuthModal = useCallback(({ mode = 'signup', onSuccess } = {}) => {
    setState({ isOpen: true, mode, onSuccess: onSuccess || null });
  }, []);

  const closeAuthModal = useCallback(() => {
    setState(s => ({ ...s, isOpen: false }));
  }, []);

  const handleSuccess = useCallback((user) => {
    setState(s => {
      if (s.onSuccess) s.onSuccess(user);
      return { isOpen: false, mode: 'signup', onSuccess: null };
    });
  }, []);

  return (
    <AuthModalContext.Provider value={{ openAuthModal, closeAuthModal }}>
      {children}
      <AuthModal
        isOpen={state.isOpen}
        mode={state.mode}
        onClose={closeAuthModal}
        onSuccess={handleSuccess}
      />
    </AuthModalContext.Provider>
  );
}

// ─── Hook — call anywhere to trigger the sign-in/sign-up popup ──────────────
export function useAuthModal() {
  return useContext(AuthModalContext);
}
